import { render, staticRenderFns } from "./WorkshopGroupDetailModal.vue?vue&type=template&id=0a21267e&"
import script from "./WorkshopGroupDetailModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports